/* ═══════════════════════════════════════════════════════════════════════════
   APPARITION AU DEFILEMENT — et surtout, GARANTIE DE NE JAMAIS RIEN CACHER.

   Le design LUSEED fait monter chaque bloc de 26-30 px en fondu a l'entree.
   Le fondu part de `opacity:0` (voir `.ls-reveal` dans luseed.css) : si la
   classe `ls-vu` n'arrive jamais, LE CONTENU RESTE INVISIBLE POUR TOUJOURS.
   Une animation qui peut cacher la marchandise n'est pas une animation, c'est
   une panne. Tout ce fichier est ecrit autour de ce risque.

   DEUX DEFAUTS CORRIGES LE 28/08/2026, tous deux mesures sur la page reelle.

   1. LE SCRIPT ETAIT CHARGE 48 FOIS SUR UNE MEME PAGE.
      Mesure : `document.querySelectorAll('script[src*=luseed]').length` = 48
      sur la page catalogue. Motif : `luseed-tete` est rendu par CHAQUE section
      LUSEED — c'est voulu, une section doit rester autonome — et il porte la
      balise du script. Le navigateur execute une balise par occurrence.
      Consequence : 48 observateurs sur les 45 memes elements, soit plus de
      2 000 observations pour un travail qui en demande 45.
      D'ou le verrou `deja_lance` : le premier passage travaille, les 47 autres
      repartent tout de suite.

   2. AUCUN FILET SI L'OBSERVATEUR NE PARLE PAS.
      L'ancienne version ne prevoyait qu'un cas : l'absence d'IntersectionObserver.
      Or l'observateur peut EXISTER et ne rien dire — un onglet en arriere-plan
      le gele (mesure : `visibilityState: hidden` -> zero declenchement, meme sur
      un element manifestement visible), et le contenu reste alors a `opacity:0`.
      Trois filets sont donc poses, du plus immediat au plus grossier :
        a) ce qui est DEJA dans l'ecran au chargement est revele SANS observateur ;
        b) au retour de l'onglet au premier plan, on repasse ;
        c) au bout de 2,5 s, tout ce qui reste cache est revele, point final.

   ⚠️ NE PAS « SIMPLIFIER » EN RETIRANT LE FILET (c). Il ne sert a rien le jour
   ou tout marche — c'est exactement sa raison d'etre. Il coute un `setTimeout`
   et il supprime toute la famille de pannes « la page est blanche ».
   ═══════════════════════════════════════════════════════════════════════════ */
(function(){
  // Le verrou du point 1. Pose sur `window` et non dans la portee du module :
  // chacune des 48 executions a sa propre portee, seul `window` leur est commun.
  if (window.__luseedApparition) return;
  window.__luseedApparition = true;

  var CASCADE_MS = 90;      // decalage entre freres, pour l'effet d'escalier
  var RANG_MAX = 6;         // au-dela, le dernier attendrait trop longtemps
  var FILET_MS = 2500;      // apres quoi on revele tout, quoi qu'il arrive

  function reveler(el, rang){
    if (el.classList.contains('ls-vu')) return;
    if (rang) el.style.transitionDelay = (Math.min(rang, RANG_MAX) * CASCADE_MS) + 'ms';
    el.classList.add('ls-vu');
  }

  function tout(){
    document.querySelectorAll('.ls-reveal:not(.ls-vu)').forEach(function(e){ reveler(e, 0); });
  }

  // Sans observateur, ou si l'utilisateur refuse les animations : on montre tout.
  // Un contenu sans animation vaut infiniment mieux qu'un contenu invisible.
  if (!('IntersectionObserver' in window)) { tout(); return; }
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { tout(); return; }

  var obs = new IntersectionObserver(function(entrees){
    entrees.forEach(function(en){
      if (!en.isIntersecting) return;
      var el = en.target, parent = el.parentElement;
      var rang = parent ? Array.prototype.indexOf.call(parent.children, el) : 0;
      reveler(el, rang);
      obs.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  // FILET (a) — ce qui est deja sous les yeux au chargement ne doit dependre
  // d'aucun evenement. On le revele a la lecture du DOM, sans cascade : un bloc
  // deja visible n'a pas a « entrer », il est deja entre.
  function revelerCeQuiEstDejaVisible(){
    var hauteur = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll('.ls-reveal:not(.ls-vu)').forEach(function(e){
      var r = e.getBoundingClientRect();
      if (r.top < hauteur && r.bottom > 0) { reveler(e, 0); obs.unobserve(e); }
    });
  }

  function brancher(){
    revelerCeQuiEstDejaVisible();
    document.querySelectorAll('.ls-reveal:not(.ls-vu)').forEach(function(e){ obs.observe(e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', brancher);
  } else {
    brancher();
  }

  // Une section ajoutee dans l'editeur de theme arrive apres coup.
  document.addEventListener('shopify:section:load', brancher);

  // FILET (b) — l'observateur est gele tant que l'onglet est en arriere-plan.
  // Au retour au premier plan, on repasse sur ce qui est sous les yeux.
  document.addEventListener('visibilitychange', function(){
    if (document.visibilityState === 'visible') revelerCeQuiEstDejaVisible();
  });

  // FILET (c) — le dernier mot. Quelle que soit la raison pour laquelle
  // l'observateur n'a pas parle, plus rien n'est cache passe ce delai.
  setTimeout(tout, FILET_MS);
})();